import * as angular from 'angular';
import {IController} from "angular";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DeliveriesAlertsService} from "../../services/deliveries-alerts.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";
import {ServicesFacadeService} from "../../angular/services/services-facade.service";

export class DeliveryEditViewStateCtrl implements IController {
  account: AccountModel;
  delivery: any;
  customers: any;
  pricePlanBundle: any;

  public isSubmitting?: boolean = false;

  private deliveryRef: any;

  /* @ngInject */
  constructor(private $log, private $state, private $delivery, private deliveriesAlertsService: DeliveriesAlertsService, private deliveriesConstants,
              private confirmChangeStateService: ConfirmChangeStateService, private bringozLoaderService: BringozLoaderService, private servicesFacadeService: ServicesFacadeService) {
  }

  $onInit() {
    this.deliveryRef = this.$delivery(this.delivery.id);
    this.confirmChangeStateService.setIsEnabled(true);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onSubmit(delivery, isShouldSendSms, rePrice) {
    const originalDeliveryCopy = angular.copy(delivery);

    this.bringozLoaderService.on();
    this.isSubmitting = true;

    this.deliveryRef.$update(delivery, {}, {sendSms: isShouldSendSms, rePrice: rePrice})
      .then((res) => {
        this.servicesFacadeService.updateOne(res);
        // Reset transition confirmation prompt
        this.confirmChangeStateService.reset();

        this.deliveriesAlertsService.updateDeliverySuccess(originalDeliveryCopy);
        this.$state.go(this.deliveriesConstants.redirectLinkByTextTriggerGroup.Delivery, {
          id: this.delivery.id
        });
        // this.$state.go(this.deliveriesConstants.redirectLinkByTextTriggerGroup.Delivery, {id: delivery.id}, {
        //   notify: true,
        //   reload: true
        // });
      })
      .catch((error) => {
        if (error) {
          if (error.code === 400301) {
            this.deliveriesAlertsService.outOfServiceZoneError();
          } else {
            this.deliveriesAlertsService.updateDeliveryError();
          }
          this.$log.error('createOrderFlowError', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
        this.isSubmitting = false;
      });
  }

  onCancel() {
    this.$state.go(this.deliveriesConstants.redirectLinkByTextTriggerGroup.Delivery, {
      id: this.delivery.id
    });
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryEditViewState', {
    bindings: {
      account: '<',
      delivery: '<',
      customers: '<',
      pricePlanBundle: '<'
    },
    template: require('./delivery-edit-view-state.html').default,
    controller: DeliveryEditViewStateCtrl
  });
